import {readFromStorage, removeFromStorage, saveToStorage} from 'utils/storageUtils';

const STORAGE_NAME = 'loginRedirectInfo';
export const loginRedirectUrlStorage = {
    save: (href) => saveToStorage(STORAGE_NAME, { href }),
    read: () => readFromStorage(STORAGE_NAME)?.href,
    remove: () => removeFromStorage(STORAGE_NAME),
}